__turbopack_context__.v({
  "boostedTag": "styles-module__DwMxCG__boostedTag",
  "brandName": "styles-module__DwMxCG__brandName",
  "heartbeat": "styles-module__DwMxCG__heartbeat",
  "likeButton": "styles-module__DwMxCG__likeButton",
  "likeButtonUnfilled": "styles-module__DwMxCG__likeButtonUnfilled",
  "likedButtonFilled": "styles-module__DwMxCG__likedButtonFilled",
  "productAttributes": "styles-module__DwMxCG__productAttributes",
  "productAttributesContainer": "styles-module__DwMxCG__productAttributesContainer",
  "sizeAttributeText": "styles-module__DwMxCG__sizeAttributeText",
  "translucentHoverOverlay": "styles-module__DwMxCG__translucentHoverOverlay",
});
